import { webApi } from '@mi-front/api-clients';
import { Grid } from '@mui/material';
import { ReactNode } from 'react';
import { EditCard } from '../edit-card/EditCard';

export interface VideoEditionsEditGridProps {
  edits: webApi.EnrichedVideoEditorEditListItemDto[];
  onCloneEdit: (edit: webApi.EnrichedVideoEditorEditListItemDto) => void;
  onEditMutationSuccess?: () => Promise<void> | void;
  renderPublishControl?: (edit: webApi.EnrichedVideoEditorEditListItemDto) => ReactNode;
}

/**
 * Responsive grid of edit cards for the video editions tab.
 */
export function VideoEditionsEditGrid({
  edits,
  onCloneEdit,
  onEditMutationSuccess,
  renderPublishControl,
}: VideoEditionsEditGridProps) {
  return (
    <Grid container spacing={2}>
      {edits.map((edit) => (
        <EditCard
          key={edit.id}
          edit={edit}
          renderPublishControl={renderPublishControl}
          onClone={() => onCloneEdit(edit)}
          onDeleteSuccess={onEditMutationSuccess}
        />
      ))}
    </Grid>
  );
}
